export default "__VITE_ASSET__DJv6fg3Q__"